<div style="display: flex; flex-wrap: wrap; row-gap: 0.5rem">
  <ng-container *ngFor="let filter of filters; let i = index">
    <!-- <span class="asterick" style="margin-right: 3px">*</span> -->
    <div style="flex: 1 1 calc(25% - 0.5rem)">
      <!-- [ngClass]="{
        disabled:
          filter.name != 'Channel'
              ? !disableBasedOnSelectedFilter2(i).length
              : key
        }" -->
      <app-multiple-check-box-filter
        [name]="filter.name"
        [displayName]="filter.displayName"
        [options]="
          filter.options && filter.options.length ? filter.options : []
        "
        [enableSearch]="filter.enableSearch"
        (selectionChanged)="filterChange($event)"
        [isSingleSelection]="filter.isSingleSelection"
        [optionAllPresent]="
          filter.optionAllPresent == undefined ? true : filter.optionAllPresent
        "
        [isMandatory]="filter.isMandatory"
        [isDisabled]="filter.isDisabled"
        [filterMarginBottom]="
          filter.filterMarginBottom ? filter.filterMarginBottom : 20
        "
        [mandatorySymbolPosition]="filter.mandatorySymbolPosition"
        [showRadioBtnForSingleSelection]="filter.showRadioBtnForSingleSelection"
        [autoSelectedOptionWidth]="filter.autoSelectedOptionWidth"
        [menuWidth]="filter.menuWidth ? filter.menuWidth : 220"
      >
      </app-multiple-check-box-filter>
    </div>
  </ng-container>
  <mat-icon
    style="position: relative; bottom: 3px; left: 8px"
    (click)="resetFilters()"
    class="mat-icon-delete"
    *ngIf="showResetButton"
    ><svg
      width="16"
      height="16"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.1875 6.1875C6.33668 6.1875 6.47976 6.24676 6.58525 6.35225C6.69074 6.45774 6.75 6.60082 6.75 6.75V13.5C6.75 13.6492 6.69074 13.7923 6.58525 13.8977C6.47976 14.0032 6.33668 14.0625 6.1875 14.0625C6.03832 14.0625 5.89524 14.0032 5.78975 13.8977C5.68426 13.7923 5.625 13.6492 5.625 13.5V6.75C5.625 6.60082 5.68426 6.45774 5.78975 6.35225C5.89524 6.24676 6.03832 6.1875 6.1875 6.1875ZM9 6.1875C9.14918 6.1875 9.29226 6.24676 9.39775 6.35225C9.50324 6.45774 9.5625 6.60082 9.5625 6.75V13.5C9.5625 13.6492 9.50324 13.7923 9.39775 13.8977C9.29226 14.0032 9.14918 14.0625 9 14.0625C8.85082 14.0625 8.70774 14.0032 8.60225 13.8977C8.49676 13.7923 8.4375 13.6492 8.4375 13.5V6.75C8.4375 6.60082 8.49676 6.45774 8.60225 6.35225C8.70774 6.24676 8.85082 6.1875 9 6.1875ZM12.375 6.75C12.375 6.60082 12.3157 6.45774 12.2102 6.35225C12.1048 6.24676 11.9617 6.1875 11.8125 6.1875C11.6633 6.1875 11.5202 6.24676 11.4148 6.35225C11.3093 6.45774 11.25 6.60082 11.25 6.75V13.5C11.25 13.6492 11.3093 13.7923 11.4148 13.8977C11.5202 14.0032 11.6633 14.0625 11.8125 14.0625C11.9617 14.0625 12.1048 14.0032 12.2102 13.8977C12.3157 13.7923 12.375 13.6492 12.375 13.5V6.75Z"
        fill="#FA4242"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.3125 3.375C16.3125 3.67337 16.194 3.95952 15.983 4.1705C15.772 4.38147 15.4859 4.5 15.1875 4.5H14.625V14.625C14.625 15.2217 14.3879 15.794 13.966 16.216C13.544 16.6379 12.9717 16.875 12.375 16.875H5.625C5.02826 16.875 4.45597 16.6379 4.03401 16.216C3.61205 15.794 3.375 15.2217 3.375 14.625V4.5H2.8125C2.51413 4.5 2.22798 4.38147 2.017 4.1705C1.80603 3.95952 1.6875 3.67337 1.6875 3.375V2.25C1.6875 1.95163 1.80603 1.66548 2.017 1.4545C2.22798 1.24353 2.51413 1.125 2.8125 1.125H6.75C6.75 0.826631 6.86853 0.540483 7.0795 0.329505C7.29048 0.118526 7.57663 0 7.875 0L10.125 0C10.4234 0 10.7095 0.118526 10.9205 0.329505C11.1315 0.540483 11.25 0.826631 11.25 1.125H15.1875C15.4859 1.125 15.772 1.24353 15.983 1.4545C16.194 1.66548 16.3125 1.95163 16.3125 2.25V3.375ZM4.63275 4.5L4.5 4.56637V14.625C4.5 14.9234 4.61853 15.2095 4.8295 15.4205C5.04048 15.6315 5.32663 15.75 5.625 15.75H12.375C12.6734 15.75 12.9595 15.6315 13.1705 15.4205C13.3815 15.2095 13.5 14.9234 13.5 14.625V4.56637L13.3673 4.5H4.63275ZM2.8125 3.375V2.25H15.1875V3.375H2.8125Z"
        fill="#FA4242"
      />
    </svg>
  </mat-icon>
</div>
